import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TIconConfig, DEFAULT_ICON_VIEW_BOX, ICON_PATH, ALL_ICONS } from '@dss-libs/shared/type/common-types';

@Injectable({ providedIn: 'root' })
export class IconRegistryUtilityClass {
  #matIconRegistry = inject(MatIconRegistry);
  #domSanitizer = inject(DomSanitizer);

  registerIcons(): void {
    ALL_ICONS.forEach((icon: TIconConfig) => {
      this.#matIconRegistry.addSvgIcon(icon.name, this.#makeSafeUrl(icon.name), {
        viewBox: icon.viewBox ?? DEFAULT_ICON_VIEW_BOX,
      });
    });
  }

  #makeSafeUrl(iconName: string): SafeResourceUrl {
    return this.#domSanitizer.bypassSecurityTrustResourceUrl(`${ICON_PATH}/${iconName}.svg`);
  }
}
